export default __webpack_public_path__ + "static/media/checkmark.af055916.svg";